import { datadogRum } from "@datadog/browser-rum";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import React from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import App from "./App";
import { ErrorDisplay } from "@/components/ErrorDisplay";
import { RuntimeConfigurationProvider } from "@/contexts/runtimeConfigurationProvider/index";
import "@/i18n";
import { redactOAuthCallbackParameters } from "@/utils/datadogRum";
import "./index.css";

// NOTE possibly need to update thresholds to display hours for days
dayjs.extend(relativeTime);
dayjs.extend(duration);

const rumEnvs = ["dev", "stg", "prd"];

fetch("/config.json")
  .then((res) => res.json())
  .then((config) => {
    const { ENV, APP_ROLE, RELEASE_VERSION, DATADOG_CLIENT_TOKEN, DATADOG_APPLICATION_ID } = config;

    if (rumEnvs.includes(ENV)) {
      datadogRum.init({
        applicationId: DATADOG_APPLICATION_ID,
        clientToken: DATADOG_CLIENT_TOKEN,
        site: "datadoghq.eu",
        service: APP_ROLE === "backoffice" ? "backoffice" : "fbaccount",
        env: ENV,
        version: /^[\w.-]+$/.test(RELEASE_VERSION ?? "") ? RELEASE_VERSION : undefined,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
        beforeSend: redactOAuthCallbackParameters,
      });
    }
  })
  .catch((error) => console.error("Failed to initialize monitoring", error));

const container = document.getElementById("root");

const root = createRoot(container!);

root.render(
  <ErrorBoundary fallbackRender={ErrorDisplay}>
    <React.Suspense fallback="loading">
      <RuntimeConfigurationProvider>
        <App />
      </RuntimeConfigurationProvider>
    </React.Suspense>
  </ErrorBoundary>
);
